import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOSchema from '@/components/base/SEOSchema';

export default function About() {
  return (
    <>
      <ScrollToTop />
      <SEOSchema type="Organization" data={{}} />
      <SEOSchema type="WebPage" data={{
        name: '关于我们 - 色影视',
        description: '了解色影视品牌故事、发展历程与联系方式。色影视致力于为用户提供电视剧全集在线观看、电影完整版播放、综艺全集免费看的高清不缓冲观影体验。',
        url: 'https://www.seyingtv.com/about',
      }} />
      <SEOSchema type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '色影视首页', item: 'https://www.seyingtv.com/' },
          { '@type': 'ListItem', position: 2, name: '关于我们' },
        ],
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 pb-10">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '关于我们' },
              ]}
            />

            {/* Hero */}
            <section className="mt-6 relative rounded-2xl overflow-hidden p-10 md:p-16 text-center">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20media%20office%20with%20multiple%20screens%20displaying%20movies%20and%20shows%20warm%20cinematic%20lighting%20creative%20workspace%20atmosphere%20professional%20environment%20film%20posters%20on%20walls%20comfortable%20modern%20interior&width=1280&height=500&seq=about-hero-2026&orientation=landscape"
                alt="色影视品牌形象"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black/55"></div>
              <div className="relative z-10">
                <h1 className="font-heading text-2xl md:text-4xl font-bold text-white">
                  关于色影视
                </h1>
                <p className="mt-4 text-white/80 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
                  色影视致力于打造中国领先的在线影视平台，为用户提供电视剧全集在线观看、电影完整版播放、综艺全集免费看的高清不缓冲观影体验。
                </p>
              </div>
            </section>

            {/* Brand Introduction */}
            <section className="mt-14">
              <h2 className="font-heading text-2xl font-bold text-foreground-900 text-center">
                品牌介绍
              </h2>
              <div className="mt-6 max-w-3xl mx-auto text-sm text-foreground-700 leading-relaxed space-y-4">
                <p>
                  色影视成立于2020年，是一家专注于在线影视内容聚合与分发的新媒体平台。自创立以来，我们始终秉持"让每个人都能轻松享受高清影视"的使命，不断优化技术架构和内容生态，为用户带来流畅、高清、免费的追剧体验。
                </p>
                <p>
                  色影视的核心优势在于先进的自适应流媒体技术和强大的CDN加速网络。我们自主研发的不缓冲播放引擎，能够根据用户的网络环境实时调整码率，确保即使在网络条件不理想的情况下，也能实现连续播放不卡顿的观影体验。
                </p>
                <p>
                  在内容方面，色影视覆盖了电视剧全集、电影完整版、综艺全集等主要影视品类。我们的内容团队每日更新最新上线的影视剧集，确保用户第一时间观看到想看的节目。无论是热播电视剧全集在线观看，还是最新电影完整版播放，抑或是综艺全集连续观看，色影视都能满足您的需求。
                </p>
                <p>
                  展望未来，色影视将继续加大技术研发投入，拓展更多优质内容资源，提升用户体验。我们相信，通过不断的创新和努力，色影视将成为更多人日常追剧的首选平台。
                </p>
              </div>
            </section>

            {/* Reputation */}
            <section className="mt-14">
              <h2 className="font-heading text-2xl font-bold text-foreground-900 text-center">
                用户口碑
              </h2>
              <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "电视剧全集在线观看真的太方便了！之前在其他平台看剧总是缓冲卡顿，但是在色影视完全不卡，高清画质也很清晰，追剧必备神器！"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">—— 追剧达人小王</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "电影完整版的资源很全，而且都是高清的。周末在家就想看部电影放松一下，色影视的电影大全基本覆盖了我想看的所有片子，强烈推荐！"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">—— 电影爱好者小李</p>
                </div>
                <div className="bg-background-100 rounded-xl p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 text-accent-500 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "综艺全集播放连续观看功能太棒了！不用一集一集去点，自动连播非常省心。画质清晰流畅，看综艺的体验感真的很好。"
                  </p>
                  <p className="text-xs text-foreground-500 font-medium">—— 综艺控小张</p>
                </div>
              </div>
            </section>

            {/* Stats */}
            <section className="mt-14">
              <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
                <div className="text-center py-8 px-4 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="font-heading text-3xl font-bold text-primary-500">4年</div>
                  <p className="mt-2 text-sm text-foreground-600">品牌历史</p>
                </div>
                <div className="text-center py-8 px-4 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="font-heading text-3xl font-bold text-accent-500">10万+</div>
                  <p className="mt-2 text-sm text-foreground-600">影视资源</p>
                </div>
                <div className="text-center py-8 px-4 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="font-heading text-3xl font-bold text-primary-500">500万+</div>
                  <p className="mt-2 text-sm text-foreground-600">忠实用户</p>
                </div>
                <div className="text-center py-8 px-4 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="font-heading text-3xl font-bold text-accent-500">99.9%</div>
                  <p className="mt-2 text-sm text-foreground-600">服务稳定率</p>
                </div>
              </div>
            </section>

            {/* Contact */}
            <section className="mt-14">
              <h2 className="font-heading text-2xl font-bold text-foreground-900 text-center">
                联系我们
              </h2>
              <p className="mt-3 text-sm text-foreground-600 text-center max-w-xl mx-auto">
                如果您有任何问题或建议，欢迎通过以下方式与我们联系。我们的客服团队将在24小时内回复您。
              </p>
              <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
                <div className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-full mb-3">
                    <i className="ri-mail-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-sm text-foreground-600">contact@seyingtv.com</p>
                </div>
                <div className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-full mb-3">
                    <i className="ri-phone-line text-xl text-accent-500"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">客服电话</h3>
                  <p className="text-sm text-foreground-600">400-888-8888</p>
                </div>
                <div className="flex flex-col items-center text-center p-6 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-12 h-12 flex items-center justify-center bg-primary-100 rounded-full mb-3">
                    <i className="ri-map-pin-line text-xl text-primary-500"></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1">公司地址</h3>
                  <p className="text-sm text-foreground-600">北京市朝阳区建国路88号SOHO现代城A座</p>
                </div>
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}